import Auth from "@/components/Auth"
import PageNotFound from "@/components/PageNotFound"
import { ROUTES } from "@/routes"
import ForgotPasswordPage from "@/screens/auth/forgot-password/ForgotPasswordPage"
import RequestInvitationPage from "@/screens/auth/request-invitation/RequestInvitationPage"
import ResetPasswordPage from "@/screens/auth/reset-password/ResetPasswordPage"
import SignInPage from "@/screens/auth/sign-in/SignInPage"
import SignUpPage from "@/screens/auth/sign-up/SignUpPage"
import DashboardPage from "@/screens/dashboard/DashboardPage"
import AddDevicePage from "@/screens/devices/AddDevicePage"
import BloodGlucoseDeviceSetupPage from "@/screens/devices/BloodGlucoseDeviceSetupPage"
import CheckSmsPage from "@/screens/devices/CheckSmsPage"
import DeviceLinkingErrorPage from "@/screens/devices/DeviceLinkingErrorPage"
import DeviceSetupCompletedPage from "@/screens/devices/DeviceSetupCompletedPage"
import RegisterDeviceLandingPage from "@/screens/devices/RegisterDeviceLandingPage"
import AddFoodLogPage from "@/screens/measurements/AddFoodLogPage"
import EditFoodLogPage from "@/screens/measurements/EditFoodLogPage"
import EditMeasurementPage from "@/screens/measurements/EditMeasurementPage"
import EditQuickCheckPage from "@/screens/measurements/EditQuickCheckPage"
import FastingMeasurementPage from "@/screens/measurements/FastingMeasurementPage"
import MealMeasurementPage from "@/screens/measurements/MealMeasurementPage"
import QuickCheckPage from "@/screens/measurements/QuickCheckPage"
import OnboardingPage from "@/screens/onboarding/OnboardingPage"
import LinkDevicePage from "@/screens/settings/LinkDevicePage"
import SettingsPage from "@/screens/settings/SettingsPage"
import UpdateMedicationsPage from "@/screens/settings/UpdateMedicationsPage"
import UpdateProfilePage from "@/screens/settings/UpdateProfilePage"
import UpdateRemindersPage from "@/screens/settings/UpdateRemindersPage"
import ContactBloomlifePage from "@/screens/static/ContactBloomlifePage"
import InstructionVideosPage from "@/screens/static/InstructionVideosPage"
import { BrowserRouter, Route, Routes } from "react-router"
import { Toaster } from "sonner"

const App = () => (
  <>
    <BrowserRouter>
      <Routes>
        {/* Public auth */}
        <Route path={ROUTES.SIGN_IN} element={<SignInPage />} />
        <Route path={ROUTES.SIGN_UP} element={<SignUpPage />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route path={ROUTES.REQUEST_INVITATION} element={<RequestInvitationPage />} />

        {/* Public device */}
        <Route path={ROUTES.REGISTER_DEVICE_LANDING} element={<RegisterDeviceLandingPage />} />
        <Route path={ROUTES.CHECK_SMS} element={<CheckSmsPage />} />
        <Route path={ROUTES.CONTACT_BLOOMLIFE} element={<ContactBloomlifePage />} />

        {/* Protected */}
        <Route
          path={ROUTES.ONBOARDING}
          element={
            <Auth>
              <OnboardingPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.ADD_DEVICE}
          element={
            <Auth>
              <AddDevicePage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.BLOOD_GLUCOSE_DEVICE_SETUP}
          element={
            <Auth>
              <BloodGlucoseDeviceSetupPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.DASHBOARD}
          element={
            <Auth>
              <DashboardPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.MEASUREMENT.FASTING}
          element={
            <Auth>
              <FastingMeasurementPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.MEASUREMENT.MEAL}
          element={
            <Auth>
              <MealMeasurementPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.MEASUREMENT.QUICK_CHECK}
          element={
            <Auth>
              <QuickCheckPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.MEASUREMENT.EDIT}
          element={
            <Auth>
              <EditMeasurementPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.QUICK_CHECK_EDIT}
          element={
            <Auth>
              <EditQuickCheckPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.ADD_FOOD_LOG}
          element={
            <Auth>
              <AddFoodLogPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.FOOD_LOG_EDIT}
          element={
            <Auth>
              <EditFoodLogPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.SETTINGS}
          element={
            <Auth>
              <SettingsPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.LINK_DEVICE}
          element={
            <Auth>
              <LinkDevicePage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.UPDATE_PROFILE}
          element={
            <Auth>
              <UpdateProfilePage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.UPDATE_MEDICATIONS}
          element={
            <Auth>
              <UpdateMedicationsPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.UPDATE_REMINDERS}
          element={
            <Auth>
              <UpdateRemindersPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.INSTRUCTION_VIDEOS}
          element={
            <Auth>
              <InstructionVideosPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.DEVICE_SETUP_COMPLETED}
          element={
            <Auth>
              <DeviceSetupCompletedPage />
            </Auth>
          }
        />
        <Route
          path={ROUTES.DEVICE_LINKING_ERROR}
          element={
            <Auth>
              <DeviceLinkingErrorPage />
            </Auth>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
    <Toaster position="top-center" richColors duration={4000} />
  </>
)

export default App
